import React from 'react'

const TitleNews = ({ block }) => {
    return block?.content && <h4 class="baseocom-titre">{block?.content}</h4>
}

export default TitleNews
